// extracted by mini-css-extract-plugin
export default {"header":"header--YGWap","resultsPage":"resultsPage--DxGC6","logo":"logo--T8h__","socials":"socials--HxNuh","backBtn":"backBtn--X2ZxU","mobileShareBtn":"mobileShareBtn--vN6PJ"};